import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { IAuthContext } from "../../types/auth";

const useAuth = () => {
	return useContext(AuthContext) as IAuthContext;
};

export { useAuth };